import { Route, Routes } from "react-router-dom";
import { AuthLayout } from "./AuthLayout";
import { VerifyPhoneNumber } from "./components/VerifyPhoneNumber";
import { RegisterOrLogin } from "./components/RegisterOrLogin";

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path="verify-phonenumber" element={<VerifyPhoneNumber />} />
      <Route path="register-login" element={<RegisterOrLogin />} />
      <Route index element={<VerifyPhoneNumber />} />
    </Route>
  </Routes>
);

export { AuthPage };
